import { Typography, Box } from '@mui/material';
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import { formatDate } from "../../../helpers/UtilityHelper";
import { primaryTextSx, secondaryTextSx, cellStackSx } from '../../orders/list2/cellStyles';

function StatusLog(props) {
  const { id } = props;
  const data = id.statusLog;

  const columns = [
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={cellStackSx}>
          <Typography sx={primaryTextSx}>{params.row.status}</Typography>
        </Box>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      flex: 0.8,
      minWidth: 130,
      renderCell: (params) => (
        <Box sx={cellStackSx}>
          <Typography sx={secondaryTextSx}>{formatDate(params.row.date)}</Typography>
        </Box>
      ),
    },
    {
      field: "remark",
      headerName: "Remarks",
      flex: 1.5,
      minWidth: 200,
      renderCell: (params) => (
        <Box sx={cellStackSx}>
          <Typography sx={secondaryTextSx}>{params.row.remark}</Typography>
        </Box>
      ),
    },
    {
      field: "submittedBy",
      headerName: "Submitted By",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <Box sx={cellStackSx}>
          <Typography sx={secondaryTextSx}>{params.row.submittedBy}</Typography>
        </Box>
      ),
    },
  ];
  return (
    <ProzoDataGrid
      columns={columns}
      autoHeight={true}
      rows={data || []}
      pagination={false}
      hideFooterPagination={true}
      getRowId={(row) => row?.date+row?.status}
    />
  );
}

export default StatusLog;
